// Meet wat bezoekers in de keuzehulp van Aiden doen, en stuurt dat naar onze eigen collector.
//
// Aiden draait in een iframe van app.aiden.cx en stuurt met postMessage gebeurtenissen naar de
// pagina (de "Build your own"-integratie in Aiden, die aan staat). Aiden zelf heeft geen API om
// zijn cijfers op te halen, en het doorsturen naar Google Analytics kost een duurdere licentie.
// Dit script vangt de berichten op en zet ze in hetzelfde logboek als onze eigen quiz, met
// "aiden-" voor de soort. npm run quiz-ophalen zet ze daarna in de BI-database.
//
// Welke berichten (uit Aidens eigen handleiding, "Gather insights with your CRM/CDP"):
//   conversation-started-event -> aiden-start (niet in de handleiding, wel waargenomen)
//   answered-event         -> aiden-antwoord   vraag = de vraag, waarde = de antwoorden, met " | "
//   advised-event          -> aiden-advies     één per geadviseerd product: product, stap = plek
//   product-clicked-event  -> aiden-klik       product = het aangeklikte product
//   start-over-event       -> aiden-opnieuw
//   customer-info          -> genegeerd: daar zit het e-mailadres van de bezoeker in.
// Bij elke gebeurtenis gaat mee welke Aiden-keuzehulp het was (bron) en op welke pagina (pad).
//
// Dezelfde afspraken als de meting van de quiz: alleen gedrag, geen persoonsgegevens; een
// sessie-id dat met het tabblad verdwijnt (dezelfde als de quiz, zodat één bezoek één sessie is);
// een testbrowser (?heko_test=1) markeert alles als test. De collector laat alleen velden door die
// hij kent, dus alleen die worden gebruikt.
(function () {
  "use strict";
  var MEETPUNT = "https://hekosolar.com/apps/meting";

  function sessie() {
    try {
      var bestaand = sessionStorage.getItem("heko-quiz-sessie");
      if (bestaand) return bestaand;
      var nieuw = "s-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem("heko-quiz-sessie", nieuw);
      return nieuw;
    } catch (e) {
      return "s-los-" + Math.random().toString(36).slice(2, 8);
    }
  }

  function isTest() {
    try {
      var p = new URL(window.location.href).searchParams.get("heko_test");
      if (p === "1") localStorage.setItem("heko-quiz-test", "1");
      if (p === "0") localStorage.removeItem("heko-quiz-test");
      return localStorage.getItem("heko-quiz-test") === "1";
    } catch (e) {
      return false;
    }
  }

  function kort(tekst) {
    return String(tekst == null ? "" : tekst).replace(/\s+/g, " ").trim().slice(0, 200);
  }

  function verstuur(gebeurtenissen) {
    if (!gebeurtenissen.length) return;
    var lading = JSON.stringify({ sessie: sessie(), gebeurtenissen: gebeurtenissen });
    try {
      // text/plain, net als de quiz: met application/json gooit de browser een beacon stil weg.
      if (navigator.sendBeacon && navigator.sendBeacon(MEETPUNT, new Blob([lading], { type: "text/plain;charset=UTF-8" }))) return;
      fetch(MEETPUNT, { method: "POST", body: lading, headers: { "Content-Type": "text/plain" }, keepalive: true });
    } catch (e) {
      // Meten mag Aiden nooit hinderen.
    }
  }

  function gebeurtenis(soort, bericht, velden) {
    var g = { op: new Date().toISOString(), soort: soort, bron: kort(bericht.advisorName), pad: window.location.pathname };
    for (var k in velden) g[k] = velden[k];
    if (isTest()) g.test = true;
    return g;
  }

  window.addEventListener("message", function (e) {
    // Alleen berichten van Aiden: van hun domein, en met de naam van een keuzehulp erin.
    if (!/(^|\.)aiden\.cx$/.test((e.origin || "").replace(/^https?:\/\//, ""))) return;
    var b = e.data;
    if (!b || typeof b !== "object" || !b.advisorName) return;
    var d = b.data || {};
    var uit = [];
    switch (b.type) {
      // Niet in Aidens handleiding, wel gezien op de winkel (2026-10-06): komt zodra iemand op
      // "Beginnen" klikt. Zonder dit weet je niet hoeveel mensen Aiden openden en direct afhaakten.
      case "conversation-started-event":
        uit.push(gebeurtenis("aiden-start", b, {}));
        break;
      case "answered-event":
        uit.push(gebeurtenis("aiden-antwoord", b, { vraag: kort(d.question), waarde: (d.answers || []).map(kort).join(" | ") }));
        break;
      case "advised-event":
        (d.products || []).forEach(function (p, i) {
          uit.push(gebeurtenis("aiden-advies", b, { product: kort(p.name), stap: i + 1, van: (d.products || []).length }));
        });
        break;
      case "product-clicked-event":
        uit.push(gebeurtenis("aiden-klik", b, { product: kort(b.productName || d.productName) }));
        break;
      case "start-over-event":
        uit.push(gebeurtenis("aiden-opnieuw", b, {}));
        break;
      // customer-info bewust niet: daar zit het e-mailadres in.
    }
    verstuur(uit);
  });
})();
